import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { IoMdOpen } from "react-icons/io";
import { fontstyle1 } from "../../../utils/fonts";
import instance from "../../../utils/axios";
import history from "../../../utils/history"

const FeedbackTable = () => {
  const [popup, setPopup] = useState(false);
  const [data, setData] = useState([]);
  const [_ppid,setppid] = useState();

  const { id, pid } = useParams();

  useEffect(() => {
    instance
      .post("/getFeedbacks", {
        uid: id,
        pid: pid
      })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((err) => console.log(err));
  }, [id, pid]);

  const getProjectinfo = (ppid) => {
    instance
      .post("/getprojectbyid", {
        uid: id,
        pid: pid,
        id: ppid
      })
      .then((res) => {
        const result = res.data.data[0];
        document.getElementById("username").value = result.username;
        document.getElementById("email").value = result.email;
        document.getElementById("phone").value = result.phone;
        document.getElementById("feedback1").value = result.feedback1;
        document.getElementById("feedback2").value = result.feedback2;
        document.getElementById("feedback3").value = result.feedback3;
        setppid(ppid);
      })
      .catch((err) => console.log(err));
  };

  const deletefeedback = ()=>{
    instance
      .post("/deletefeedback", {
        uid: id,
        pid: pid,
        id: _ppid
      })
      .then((res) => {
        if(res.data.status === "success"){
          history.go();
        }
      })
      .catch((err) => console.log(err));
  }

  return (
    <>
      <div
        className="bg-white shadow mt-10 px-5 overflow-y-auto rounded shadow-black mb-5"
        style={fontstyle1}
      >
        <table className="w-full whitespace-nowrap">
          <thead>
            <tr className="h-16 w-full text-sm leading-none text-gray-800">
              <th className="font-normal text-left pl-4">Username</th>
              <th className="font-normal text-left pl-12">Email Id</th>
              <th className="font-normal text-left pl-12">Phone Number</th>
              <th className="font-normal text-left pl-12">Feedback 1</th>
              <th className="font-normal text-left pl-12">Feedback 2</th>
              <th className="font-normal text-left pl-12">Feedback 3</th>
              <th className="font-normal text-left pl-12">View</th>
            </tr>
          </thead>
          <tbody className="w-full">
            {data.map((item, index) => (
              <tr className="h-20 text-sm leading-none text-gray-800 bg-white hover:bg-gray-100 border-b border-t border-gray-100">
                <td className="pl-4">
                  <div className="flex items-center">
                    <div className="w-10 h-10">
                      <img
                        className="w-full h-full rounded"
                        src={
                          "https://avatars.dicebear.com/api/initials/" +
                          item.username +
                          ".svg"
                        }
                        alt="demo"
                      />
                    </div>
                    <div className="pl-4">
                      <p className="font-medium">{item.username}</p>
                    </div>
                  </div>
                </td>
                <td className="pl-12">
                  <p className="text-sm font-medium leading-none text-gray-800">
                    {item.email}
                  </p>
                </td>
                <td className="pl-12">
                  <p className="font-medium">{item.phone}</p>
                </td>
                <td className="pl-12">
                  <p className="font-medium overflow-clip text-ellipsis w-24">
                    {item.feedback1}
                  </p>
                </td>
                <td className="pl-12">
                  <p className="font-medium overflow-clip text-ellipsis w-24 ">
                    {item.feedback2}
                  </p>
                </td>
                <td className="pl-12">
                  <p className="font-medium overflow-clip text-ellipsis w-24">
                    {item.feedback3}
                  </p>
                </td>
                <td className="pl-12">
                  <div
                    className="text-black text-2xl cursor-pointer"
                    onClick={() => {
                      setPopup(true);
                      getProjectinfo(item._id);
                    }}
                  >
                    <IoMdOpen />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* Popup form */}
      {popup ? (
        <div
          className="fixed top-0 left-0 right-0 bg-[#101426] bg-opacity-75 h-full w-full flex items-center justify-center"
          style={fontstyle1}
        >
          <div className="container mx-auto w-11/12 md:w-2/3 max-w-lg">
            <div className="relative py-8 px-5 md:px-10 bg-white shadow-md rounded border border-gray-400 ">
              <form>
                <h1 className="text-gray-800 font-lg font-bold tracking-normal leading-tight mb-4">
                  Users Feedback
                </h1>
                <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                  User name
                </label>
                <input
                  readOnly
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  id="username"
                />
                <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                  Email Id
                </label>
                <input
                  readOnly
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  id="email"
                />
                <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                  Phone Number
                </label>
                <input
                  readOnly
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  id="phone"
                />
                <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                  Feedback 1
                </label>
                <textarea
                  readOnly
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  id="feedback1"
                />
                <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                  Feedback 2
                </label>
                <textarea
                  readOnly
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  id="feedback2"
                />
                <label className="text-gray-800 text-sm font-bold leading-tight tracking-normal">
                  Feedback 3
                </label>
                <textarea
                  readOnly
                  className="mb-5 mt-2 text-gray-600 focus:outline-none focus:border focus:border-indigo-700 font-normal w-full h-10 flex items-center pl-3 text-sm border-gray-300 rounded border"
                  id="feedback3"
                />

                <div className="flex items-center justify-start w-full"><div
                    onClick={() => {
                      deletefeedback()
                    }}
                    className="cursor-pointer focus:outline-none ml-3 bg-[#101426] transition duration-150 text-white ease-in-out  border rounded px-8 py-2 text-sm"
                  >
                    DeleteFeedback
                  </div>
                  <div
                    onClick={() => {
                      setPopup(false);
                    }}
                    className="cursor-pointer focus:outline-none ml-3 bg-[#101426] transition duration-150 text-white ease-in-out  border rounded px-8 py-2 text-sm"
                  >
                    Cancel
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};
export default FeedbackTable;
